<template>
    <table id="datatable" class="table table-striped table-hover rounded-4 overflow-hidden my-5 w-100">
        <thead>
            <tr>
                <th class="no-sort"></th>
                <th class="text-center text-nowrap" role="button">
                    <i class="fa-solid fa-credit-card me-2"></i>
                    {{ $t('DataTable.labels.truncated_pan') }}
                </th>
                <th class="text-center text-nowrap" role="button">
                    <i class="fa-solid fa-clock me-2"></i>
                    {{ $t('DataTable.labels.created') }}
                </th>
                <th class="text-center text-nowrap" role="button">
                    <i class="fa-solid fa-gear me-2"></i>
                    {{ $t('DataTable.labels.manage') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(tr, index) in tbody" :key="index">
                <td class="dtr-control text-center align-middle">
                    <i class="fa-solid fa-chevron-down"></i>
                </td>
                <td class="text-nowrap align-middle" @click="$emit('getDetails', tr), onManage = false">
                    <div class="d-flex justify-content-center align-items-center flex-wrap">
                        <img :src="require(`@/assets/img/card_schemes/${tr.label}.svg`)" class="card-scheme">
                        <span class="truncated_pan">
                            {{ tr.truncated_pan }}
                            <i class="fa-solid fa-mobile-screen-button fs-2 ms-2" v-if="tr.form_factors_name === 'DEVICE'"></i>
                        </span>
                    </div>
                </td>
                <td class="text-nowrap align-middle" @click="$emit('getDetails', tr), onManage = false">
                    <div class="d-flex justify-content-center align-items-center">
                        <span class="badge rounded-pill font-monospace created">
                            {{ tr.created }}
                        </span>
                    </div> 
                </td>
                <td class="text-center text-nowrap align-middle">
                    <span class="btn btn-bc-delete option" @click="onManage = index" v-if="onManage !== index">
                        <i class="fa-regular fa-pen-to-square"></i>
                    </span>
                    <div class="d-flex-align-items-center" v-else>
                        <i class="btn btn-bc-delete option fa-solid fa-xmark me-2" @click="onManage = null"></i>
                        <i class="btn btn-bc-delete fa-solid fa-trash" @click="$emit('askDelete', tr)"></i>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'BankCardsDataTable',
    props: {
        tbody: Array
    },
    data() {
        return {
            onManage: null
        }
    },
    created() {
        $(document).ready(() => {
            var BankCardsDataTable = $('#datatable').DataTable({
                dom: `<'d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap'
						<'col-12 col-sm-4'l>
						<'col-12 col-sm-4'f>>` +
                    "<'d-flex'<'col-12'tr>>" +
                    `<'d-flex align-items-center flex-wrap'
                        <'col-12 col-md-5 text-center text-md-start'i>
                        <'col-12 col-md-7'p>>`,
                language: {
                    lengthMenu: this.$t('DataTable.lengthMenu'),
                    search: '',
                    searchPlaceholder: this.$t('DataTable.search'),
                    info: this.$t('DataTable.info'),
                    paginate: {
                        previous: '<i class="fa-solid fa-circle-chevron-left"></i>',
                        next: '<i class="fa-solid fa-circle-chevron-right"></i>'
                    },
                    zeroRecords: this.$t('DataTable.zeroRecords'),
                    infoFiltered: this.$t('DataTable.infoFiltered'),
                    infoEmpty: this.$t('DataTable.infoEmpty'),
                },
                responsive: {
                    details: {
                        type: 'column',
                        renderer: (api, rowIdx, columns) => {
                            var data = $.map(columns, (col) => {
                                if (col.hidden === false) {
                                    return ''
                                }
                                var row = $('<tr>', {
                                    'data-dt-row': col.rowIndex,
                                    'data-dt-column': col.columnIndex
                                })
                                    .append(
                                        $('<td>', {
                                            class: "py-2"
                                        })
                                            .html(col.title)
                                            .css('font-size', '14px'))
                                    .append(
                                        $('<td>', {
                                            class: col.className
                                        }).html(col.data))

                                return row.get(0).outerHTML
                            }).join('')
                            return data ? $('<table class="w-100 table-sm">').append(data) : false
                        }
                    }
                },
                columnDefs: [{
                    className: 'dtr-control',
                    orderable: false,
                    width: '0%',
                    targets: 0
                }, {
                    width: '40%',
                    orderable: false,
                    targets: [1,2]
                }, {
                    width: '20%',
                    orderable: false,
                    targets: 3
                }, {
                    type: 'date',
                    targets: 2
                }],
                order: [
                   [2, 'desc'] 
                ]
            })
            $('input').removeClass('form-control form-control-sm')
            $('select').removeClass('form-select form-select-sm')

            BankCardsDataTable.on('responsive-resize', (e, datatable) => {
                datatable.responsive.rebuild().columns.adjust().responsive.recalc()
            })

            BankCardsDataTable.on('responsive-display', (e, api, row, showHide) => {
                var rowOpened = $(api.row(row.index()).node())
                if (showHide) {
                    rowOpened.find('td.dtr-control').empty().append(`<i class="fa-solid fa-chevron-up"></i>`)
                } else {
                    rowOpened.find('td.dtr-control').empty().append(`<i class="fa-solid fa-chevron-down"></i>`)
                }
            })
        })
    }
}
</script>

<style>

</style>